import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";
import Icon from "../../Icon";

const CartItem = () => {
  const [qty1, setQty1] = useState(1);
  const [qty2, setQty2] = useState(2);
  const [qty3, setQty3] = useState(3);
  const [qty4, setQty4] = useState(1);
  const [qty5, setQty5] = useState(2);
  const [qty6, setQty6] = useState(1);
  const [qty7, setQty7] = useState(1);
  const [qty8, setQty8] = useState(2);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* SECTION 1: BASIC CART ITEMS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Basic Cart Items</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          
          {/* Variation 1: Simple Display */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Simple Display</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-3">
                <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-500 rounded flex-shrink-0"></div>
                <div className="flex-1">
                  <h4 className="text-sm font-semibold text-slate-100">Wireless Mouse</h4>
                  <p className="text-xs text-slate-400">SKU: WM-2024</p>
                  <p className="text-sm font-bold text-amber-400 mt-2">$24.99</p>
                </div>
                <button className="text-slate-400 hover:text-red-400 text-lg font-bold"><Icon name="close" className="w-4 h-4" /></button>
              </div>
            </div>
            <CopyCode number_code={1} code={"<div className=\"flex gap-3 p-3 bg-slate-950 rounded\">\n  <img src=\"product.jpg\" className=\"w-16 h-16 rounded\" />\n  <div className=\"flex-1\">\n    <h4 className=\"font-semibold\">Wireless Mouse</h4>\n    <p className=\"text-xs text-slate-400\">SKU: WM-2024</p>\n    <p className=\"font-bold text-amber-400\">$24.99</p>\n  </div>\n  <button className=\"text-red-400\">Remove</button>\n</div>"} />
          </div>

          {/* Variation 2: With Quantity */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Quantity Controls</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-3">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-amber-600 rounded flex-shrink-0"></div>
                <div className="flex-1">
                  <h4 className="text-sm font-semibold text-slate-100">USB-C Laptop</h4>
                  <p className="text-sm text-slate-400 mt-1">$599.99</p>
                  <div className="flex items-center gap-2 mt-2">
                    <button onClick={() => setQty1(Math.max(1, qty1 - 1))} className="px-2 py-0.5 bg-slate-700 hover:bg-slate-600 text-xs text-slate-200 rounded font-bold">-</button>
                    <span className="w-8 text-center text-sm font-semibold">{qty1}</span>
                    <button onClick={() => setQty1(qty1 + 1)} className="px-2 py-0.5 bg-slate-700 hover:bg-slate-600 text-xs text-slate-200 rounded font-bold">+</button>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-sm font-bold text-amber-400">${(599.99 * qty1).toFixed(2)}</p>
                  <button className="text-xs text-red-400 hover:text-red-300 mt-3">Remove</button>
                </div>
              </div>
            </div>
            <CopyCode number_code={2} code={"const [qty, setQty] = useState(1);\n\n<div className=\"flex gap-3 p-3\">\n  <img className=\"w-16 h-16 rounded\" />\n  <div className=\"flex-1\">\n    <h4>USB-C Laptop</h4>\n    <p className=\"text-slate-400\">$599.99</p>\n    <div className=\"flex items-center gap-2 mt-2\">\n      <button onClick={() => setQty(Math.max(1, qty - 1))}>-</button>\n      <span>{\"{\"}qty{\"}\"}}</span>\n      <button onClick={() => setQty(qty + 1)}>+</button>\n    </div>\n  </div>\n  <p className=\"font-bold\">${\"{\"}(599.99 * qty).toFixed(2){\"}\"}}</p>\n</div>"} />
          </div>

          {/* Variation 3: With Discount */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Discount Badge</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-3">
                <div className="w-16 h-16 bg-gradient-to-br from-amber-600 to-amber-600 rounded flex-shrink-0 relative">
                  <div className="absolute -top-2 -right-2 px-2 py-1 bg-red-600 text-white text-xs rounded-full font-bold">-30%</div>
                </div>
                <div className="flex-1">
                  <h4 className="text-sm font-semibold text-slate-100">Mechanical Keyboard</h4>
                  <div className="mt-1 space-y-0.5">
                    <p className="text-xs text-slate-500 line-through">$149.99</p>
                    <p className="text-sm font-bold text-green-400">$104.99</p>
                  </div>
                  <p className="text-xs text-slate-400 mt-1">Save $45.00!</p>
                </div>
              </div>
            </div>
            <CopyCode number_code={3} code={"<div className=\"flex gap-3 p-3 relative\">\n  <img className=\"w-16 h-16 rounded\" />\n  <div className=\"absolute -top-2 -right-2 px-2 py-1\n    bg-red-600 text-white text-xs rounded-full font-bold\">\n    -30%\n  </div>\n  <div className=\"flex-1\">\n    <h4>Mechanical Keyboard</h4>\n    <p className=\"line-through text-slate-500\">$149.99</p>\n    <p className=\"font-bold text-green-400\">$104.99</p>\n  </div>\n</div>"} />
          </div>

          {/* Variation 4: Stock Status */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Low Stock Warning</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-3">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-amber-500 rounded flex-shrink-0"></div>
                <div className="flex-1">
                  <h4 className="text-sm font-semibold text-slate-100">4K Monitor</h4>
                  <p className="text-sm text-slate-400 mt-1">$349.99</p>
                  <div className="mt-2 px-2 py-1 bg-orange-900/30 border border-orange-700/50 rounded">
                    <p className="text-xs text-orange-300 inline-flex items-center gap-1"><Icon name="warning" className="w-3 h-3" /> Only 2 left in stock</p>
                  </div>
                </div>
                <button className="text-red-400 hover:text-red-300 font-bold"><Icon name="close" className="w-4 h-4" /></button>
              </div>
            </div>
            <CopyCode number_code={4} code={"<div className=\"p-3 bg-slate-950 rounded border border-slate-600\">\n  <div className=\"flex gap-3\">\n    <img className=\"w-16 h-16 rounded\" />\n    <div className=\"flex-1\">\n      <h4>4K Monitor</h4>\n      <p className=\"text-slate-400\">$349.99</p>\n      <div className=\"mt-2 px-2 py-1 bg-orange-900/30\n        border border-orange-700/50 rounded\">\n        <p className=\"text-xs text-orange-300\">Only 2 left</p>\n      </div>\n    </div>\n  </div>\n</div>"} />
          </div>

        </div>
      </div>

      {/* SECTION 2: ADVANCED VARIANTS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Variants</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          
          {/* Variation 5: Wishlist Item */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Wishlist Item</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-3">
                <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-500 rounded flex items-center justify-center text-xl flex-shrink-0">??</div>
                <div className="flex-1">
                  <div className="flex items-start justify-between">
                    <div>
                      <h4 className="text-sm font-semibold text-slate-100">Designer Handbag</h4>
                      <p className="text-xs text-slate-400 mt-1">Luxury Collection</p>
                      <p className="text-sm font-bold text-amber-400 mt-2">$285.00</p>
                    </div>
                    <button className="text-amber-400 text-lg">?</button>
                  </div>
                  <button className="mt-2 w-full px-2 py-1 bg-amber-600 hover:bg-amber-500 text-xs font-semibold text-white rounded text-center">Move to Cart</button>
                </div>
              </div>
            </div>
            <CopyCode number_code={5} code={"<div className=\"flex gap-3 p-3\">\n  <div className=\"text-2xl\">??</div>\n  <div className=\"flex-1\">\n    <div className=\"flex justify-between\">\n      <div>\n        <h4>Designer Handbag</h4>\n        <p className=\"text-amber-400 font-bold\">$285.00</p>\n      </div>\n      <button className=\"text-amber-400\">?</button>\n    </div>\n    <button className=\"mt-2 w-full px-2 py-1\n      bg-amber-600 text-white rounded\">\n      Move to Cart\n    </button>\n  </div>\n</div>"} />
          </div>

          {/* Variation 6: Bundle Deal */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Bundle Deal</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-3">
                <div className="w-16 h-16 bg-gradient-to-br from-green-600 to-emerald-600 rounded flex items-center justify-center text-xl flex-shrink-0">??</div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <h4 className="text-sm font-semibold text-slate-100">Office Bundle Pro</h4>
                    <span className="text-xs bg-green-600/30 text-green-300 px-2 py-0.5 rounded">Bundle</span>
                  </div>
                  <p className="text-xs text-slate-400 mt-1">3 items included</p>
                  <div className="flex items-center justify-between mt-2">
                    <div>
                      <p className="text-xs text-slate-500 line-through">$599.97</p>
                      <p className="text-sm font-bold text-green-400">$399.99</p>
                    </div>
                    <p className="text-xs text-green-400 font-semibold">Save $200</p>
                  </div>
                </div>
              </div>
            </div>
            <CopyCode number_code={6} code={"<div className=\"flex gap-3 p-3\">\n  <div className=\"text-2xl\">??</div>\n  <div className=\"flex-1\">\n    <div className=\"flex justify-between\">\n      <h4>Office Bundle Pro</h4>\n      <span className=\"text-xs bg-green-600/30 text-green-300\n        px-2 py-0.5 rounded\">Bundle</span>\n    </div>\n    <p className=\"text-xs text-slate-400\">3 items included</p>\n    <div className=\"flex justify-between mt-2\">\n      <p className=\"line-through text-slate-500\">$599.97</p>\n      <p className=\"text-green-400 font-bold\">$399.99</p>\n    </div>\n  </div>\n</div>"} />
          </div>

          {/* Variation 7: Pre-order Item */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Pre-order Item</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-3">
                <div className="w-16 h-16 bg-gradient-to-br from-indigo-600 to-blue-600 rounded flex items-center justify-center text-xl flex-shrink-0">??</div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <h4 className="text-sm font-semibold text-slate-100">GPT-5 AI Chip</h4>
                    <span className="text-xs bg-blue-600/30 text-blue-300 px-2 py-0.5 rounded">Pre-order</span>
                  </div>
                  <p className="text-xs text-slate-400 mt-1">Estimated: April 2025</p>
                  <p className="text-sm font-bold text-amber-400 mt-2">$1,299.99</p>
                </div>
              </div>
            </div>
            <CopyCode number_code={7} code={"<div className=\"flex gap-3 p-3\">\n  <div className=\"text-2xl\">??</div>\n  <div className=\"flex-1\">\n    <div className=\"flex justify-between\">\n      <h4>GPT-5 AI Chip</h4>\n      <span className=\"text-xs bg-blue-600/30 text-blue-300\n        px-2 py-0.5 rounded\">Pre-order</span>\n    </div>\n    <p className=\"text-xs text-slate-400\">Estimated: April 2025</p>\n    <p className=\"text-amber-400 font-bold\">$1,299.99</p>\n  </div>\n</div>"} />
          </div>

          {/* Variation 8: Subscription Item */}
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Subscription Item</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-3">
                <div className="w-16 h-16 bg-gradient-to-br from-violet-600 to-amber-600 rounded flex items-center justify-center text-xl flex-shrink-0">??</div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <h4 className="text-sm font-semibold text-slate-100">Premium Support</h4>
                    <span className="text-xs bg-violet-600/30 text-violet-300 px-2 py-0.5 rounded">Monthly</span>
                  </div>
                  <p className="text-xs text-slate-400 mt-1">Auto-renews monthly</p>
                  <div className="flex items-center justify-between mt-2">
                    <p className="text-sm font-bold text-violet-400">$29.99/mo</p>
                    <button className="px-2 py-0.5 bg-red-600/20 hover:bg-red-600/30 text-xs text-red-400 rounded">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
            <CopyCode number_code={8} code={"<div className=\"flex gap-3 p-3\">\n  <div className=\"text-2xl\">??</div>\n  <div className=\"flex-1\">\n    <div className=\"flex justify-between\">\n      <h4>Premium Support</h4>\n      <span className=\"bg-violet-600/30 text-violet-300\n        text-xs px-2 py-0.5 rounded\">Monthly</span>\n    </div>\n    <p className=\"text-slate-400 text-xs\">Auto-renews monthly</p>\n    <div className=\"flex justify-between mt-2\">\n      <p className=\"font-bold text-violet-400\">$29.99/mo</p>\n      <button className=\"text-red-400\">Cancel</button>\n    </div>\n  </div>\n</div>"} />
          </div>

        </div>
      </div>
    </div>
  );
};

export default CartItem;


